import { Navigate, useLocation } from 'react-router-dom';

interface RequireAuthProps {
  children: JSX.Element;
  roles?: string[];
}

export const RequireAuth = ({ children, roles }: RequireAuthProps) => {
  const location = useLocation();
  const user = JSON.parse(
    localStorage.getItem('aquatics_hub_2025_user') || 'null',
  );

  if (!user || (roles && !roles.includes(user.role))) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
};
